const live_classes_fr = require('./live_classes.json')
export default live_classes_fr
